import { Controller } from '@hotwired/stimulus';

export default class SelectedGraphController extends Controller {
  static targets = ['select', 'container', 'card'];

  connect() {
    this.showSelectedGraph();
    this.setupSelect2ChangeListener();
  }

  setupSelect2ChangeListener() {
    $(this.selectTarget).on('change', () => {
      this.showSelectedGraph();
    });
  }

  showSelectedGraph() {
    const selectedValue = this.selectTarget.value;

    this.cardTargets.forEach(card => {
      card.classList.add('hide');
    });

    const selectedCard = this.cardTargets.find(
      card => card.dataset.graphValue === selectedValue
    );

    if (selectedCard) {
      selectedCard.classList.remove('hide');
    }
  }

  disconnect() {
    $(this.selectTarget).off('change');
  }
}
